import { programApi } from "@bw/shared/api";
import { useProgramPreviewIdentity, useProgramPreviewPage } from "@bw/shared/hooks";
import type { ProgramTrackOptionsPage } from "@bw/shared/types/generated";

/** Slim current owner option pages; prices are already Facility-derived facts. */
export function useProgramTracks(programId: string | undefined, enabled = true) {
  const identity = useProgramPreviewIdentity();
  return useProgramPreviewPage<ProgramTrackOptionsPage>({
    scope: [identity, "classes", programId ?? "", "authenticated", "options"],
    enabled: Boolean(programId) && enabled,
    load: (cursor, signal) => programApi.getTracks(programId as string,
      { limit: 25, ...(cursor ? { cursor } : {}) }, signal),
  });
}
